import axios from 'axios';
import authHeader from './auth-header';
import store from "../store";

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/user-chart/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/user-chart/';

class UserChartService {

  getAllCharts() {
    return axios.get(`${API_URL}`);
  }

  getUploadURL(chartId,filename) {
    return axios.get(`${API_URL}${chartId}/uploadURL/${filename}`);
  }

  postChart(chart) {
    return axios.post(`${API_URL}`,chart);
  }

  getChartData(chartId,filename,componentId,categoryId,toolId) {
    return axios.get(`${API_URL}${chartId}/key/${filename}/compId/${componentId}/catId/${categoryId}/tId/${toolId}`);
  }

}

export default new UserChartService();



// WEBPACK FOOTER //
// ./src/services/user-chart.service.js